import React, { useMemo, useState } from 'react';
import GijgoGrid from '../../../../Core/Controls/GijgoGrid';
import { BreadCrumbs, EditButton, formatters } from '../../../../Core/Controls';
import ReactDOM from 'react-dom';
import { Grid } from '@material-ui/core';
import { ChipWithoutLable } from '../../../../Core/Controls/Inputs/DatePicker';
import LinkIcon from '@material-ui/icons/Link';
import { Link, useHistory } from 'react-router-dom';
import CompleteScheduleModal from '../../Schedule/completeSchedule';
import DialogComp from '../../../../Core/Dialog/DialogComp';
import ContractSetDeliveryDateModal from './statusModals/ContractSetDeliveryDateModal';
import ContractSetCollectedModal from './statusModals/ContractSetCollectedModal';
import ContractSetOnsiteDateModal from './statusModals/ContractSetOnsiteDateModal';
import ContractSetOffHireModal from './statusModals/ContractSetOffHireModal';
import ContractSetVehiclePickedModal from './statusModals/ContractSetVehiclePickedModal';
import CompleteScheduleModalForContract from './statusModals/completeSchedule';
import ContractSetAwaitingFactoryInspection from './statusModals/ContractSetAwaitingFactoryInspection';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { CustomIconButton } from '../../../../Core/Controls/Inputs/Buttons/ButtonModal';
import ContractSetPauseCompleted from './statusModals/ContractSetPausedComplete';
import ContractSetResume from './statusModals/ContractSetResumeContract';
import SelectedVehicleTableComp from './statusModals/SelectedVehicleTableComp';
import { getVehicleContractByStatusXLSX } from '../../../../Core/Services/InternalUser/Vehicle/vehicleTabChecks';
import moment from 'moment';
var $ = window.$;
const baseColumns = [
    // {
    //     key: 'action',
    //     name: 'Action',
    //     width: 80
    //     // addFileUploaderIcon: true
    // },
    {
        key: 'reg',
        name: 'Reg Number',
        width: 100
        // events: {
        //     click: function (e) {
        //         props.history.push(`/controller/editVehicle/${e.data.record.vehicleID}`);
        //     }
        // }
    },
    { key: 'cref', name: 'Ref', width: 100 },
    { key: 'vehicleType', name: 'Vehicle Type', width: 90 },
    { key: 'cust', name: 'Customer', width: 200 },
    { key: 'depot', name: 'Depot', width: 200 },
    // {
    //     key: 'startDate',
    //     name: 'Start Date',
    //
    //     width: 100
    // },
    // { key: 'osd', name: 'Onsite Date',    width: 100 },
    { key: 'sa', name: 'Service Area', width: 130 }
    // { key: 'engineer', name: 'Engineer', width: 130 },
    // { key: 'purchaseOrder', name: 'Purchase Order', width: 200 },
    // { key: 'rate', name: 'Rate',  width: 80, align: 'right' }
    // { key: 'weeklyTotal', name: 'Weekly Total',   width: 80, align: 'right' }
    // { key: 'status', name: 'Status', width: 190 }
];

const ContractStatusScreen = (props) => {
    let history = useHistory();
    const [openDialog, setOpenDialog] = useState({});
    const [state, setState] = useState({
        selectedRowData: {},
        checkedVehicleList: [],
        selectedRecords: []
    });

    // const renderEdit = (ev, row) => {
    //     return (
    //         <div
    //             style={{
    //                 textAlign: 'center'
    //             }}
    //         >
    //             <EditButton
    //                 toolTipTitle="Edit Schedule Events"
    //                 onClick={() => {
    //                     setState((st) => ({
    //                         ...st,
    //                         open: true,
    //                         selectedRowData: row,
    //                         isAdd: false
    //                     }));
    //                 }}
    //             />
    //         </div>
    //     );
    // };

    let ContractStatusID = +props.match?.params?.id || props.contractStatusID;
    let isIndividualScreen = +props.match?.params?.id ? true : false;
    // /VehicleContractStatus/11?ScreenName=Offhire%20Completed
    let screenName = props.location?.search?.split('ScreenName=')[1] ? decodeURIComponent(props.location.search.split('ScreenName=')[1]) : props.statusName;

    console.log(props.match, 'props.match.params.id');
    const getVal = async (gridRef, recList) => {
        let statusNextModal = '';
        var val = [];
        $(`${gridRef} tbody :checkbox:checked:not(:disabled)`).each(function (i) {
            val[i] = $(this).val();
        });

        let newIDList = [];
        let selectedRecords = [];
        let object = {};
        val.forEach((m, i) => {
            // object.
            let getValues = m - 1;
            newIDList.push(recList[getValues].contractVehicleID);
            selectedRecords.push(recList[getValues]);
        });

        console.log(selectedRecords, 'selectedRecords');

        if (+ContractStatusID == 2) statusNextModal = 'setDeliveryDateModal';
        if (+ContractStatusID == 3) statusNextModal = 'setCollectedModal';
        if (+ContractStatusID == 4) statusNextModal = 'setOnsiteDateModal';
        if (+ContractStatusID == 6) statusNextModal = 'setOffHireModal';
        if (+ContractStatusID == 8) statusNextModal = 'setVehiclePickedModal';
        if (+ContractStatusID == 9) statusNextModal = 'setAwaitingFactoryInspection';
        // if (+ContractStatusID == 10) statusNextModal = 'setPauseCompleted';
        if (+ContractStatusID == 11) statusNextModal = 'setPauseCompleted';

        setOpenDialog({ [statusNextModal]: true });
        setState((st) => ({
            ...st,
            checkedVehicleList: newIDList,
            selectedRecords: selectedRecords
        }));
    };

    const mailButton = (gridRef, valueList) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justify="center">
                <ChipWithoutLable
                    icon={LinkIcon}
                    onClick={() => getVal(gridRef, valueList)}
                    style={{ fontWeight: 'bold' }}
                    toolTipTitle={
                        ContractStatusID == 2
                            ? 'Set delivery arranged'
                            : ContractStatusID == 3
                              ? 'Set Collected'
                              : ContractStatusID == 4
                                ? 'Set On Site Date'
                                : ContractStatusID == 6
                                  ? 'Set Off Hire Date'
                                  : ContractStatusID == 9
                                    ? 'Set Vehicle Arrived'
                                    : 'Link Contract'
                    }
                />
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const handleEditRegClick = (val) => {
        if (ContractStatusID == 1) {
            history.push({
                pathname: `/controller/editVehicle/${val.vid}`,
                search: `?redirectLabel=Schedules`
            });
        } else {
            history.push({
                pathname: `/controller/editVehicle/${val.vid}`,
                search: `?redirectLabel=Contract`
            });
        }
    };

    const downloadPdf = async (fileType) => {
        let res = await getVehicleContractByStatusXLSX(ContractStatusID);

        if (res) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.getElementById('tempDownloadPDFLink') || document.createElement('a');
            link.id = 'tempDownloadPDFLink';
            link.href = url;
            link.setAttribute('download', `${props.statusName || ''}${moment().format('DD-MMM-YYYY HH:mm')}.${'xlsx'}`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            return true;
        }
    };

    // const editActionBtn = (data, row) => {
    //     return (
    //         row.summerServiceScheduleID && (
    //             <div style={{ textAlign: 'center' }}>
    //                 <CustomIconButton
    //                     icon={CheckCircleIcon}
    //                     color="primary"
    //                     onClick={() => {
    //                         checkButton(row, 'complete');
    //                     }}
    //                     toolTipTitle="Complete Schedule"
    //                 />
    //             </div>
    //         )
    //     );
    // };

    const editActionBtn = (data, row) => {
        const { contractStatusID } = props;
        const { summerServiceScheduleID, onhireScheduleID, offhireScheduleID } = row;

        // Define the condition for rendering the button
        const isScheduleValid =
            // (contractStatusID === 1 && summerServiceScheduleID) ||
            (contractStatusID === 5 && onhireScheduleID) || (contractStatusID === 7 && offhireScheduleID);

        return isScheduleValid ? (
            <div style={{ textAlign: 'center' }}>
                <CustomIconButton icon={CheckCircleIcon} color="primary" onClick={() => checkButton(row, 'complete')} toolTipTitle="Complete Schedule" />
            </div>
        ) : null;
    };

    const renderRegNo = ({ row, col }, grid) => {
        const spn = document.createElement('span');
        const lnk = (
            <div
                onClick={() => handleEditRegClick(row, 'showCustomerModal')}
                style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold', paddingLeft: '5px' }}
            >
                {row.reg}
            </div>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];

        // if (
        //     ContractStatusID == 1
        //     //  ||
        //     // ContractStatusID == 5 ||
        //     // ContractStatusID == 7
        //     // || ContractStatusID == 10
        // ) {
        //     tempCols.unshift({
        //         key: 'action',
        //         name: 'Action',
        //         width: 60,
        //         formatter: editActionBtn
        //     });
        // }

        if (ContractStatusID == 6) {
            tempCols.splice(5, 0, {
                key: 'contractWinterStartDate',
                name: 'Start Date',

                width: 100
            });
        } else {
            tempCols.splice(5, 0, {
                key: 'startDate',
                name: 'Start Date',

                width: 100
            });
        }

        if (ContractStatusID > 3) {
            tempCols.splice(6, 0, { key: 'osd', name: 'Onsite Date', width: 100 });
            tempCols.splice(7, 0, { key: 'endDate', name: 'Termination', width: 160 });
        }

        if (ContractStatusID == 5 || ContractStatusID == 7) {
            tempCols.splice(
                7,
                0,
                { key: 'earliestOffHire', name: 'Earliest Off Hire', width: 130 },
                { key: 'offhireDate', name: 'Winter Off Hire', width: 120 }
            );
        }
        if (ContractStatusID == 6) {
            tempCols.splice(
                7,
                0,

                { key: 'earliestOffHire', name: 'Earliest Off Hire', width: 130 },
                { key: 'offhireDate', name: 'Winter Off  Hire', width: 120 }
            );
        }
        if (ContractStatusID == 7) {
            tempCols.splice(7, 0, { key: 'offhireDate', name: 'Off Hire', width: 130 });
        }
        if (ContractStatusID == 4 || ContractStatusID == 5) {
            tempCols.splice(7, 0, { key: 'ContractCollectionDate', name: 'Collection Date', width: 130 });
        }

        if (ContractStatusID < 6) {
            tempCols.splice(5, 0, { key: 'deliveryDate', name: 'Delivery Date', width: 150 });
            tempCols.splice(6, 0, { key: 'delCo', name: 'Transport Company', width: 150 });
        }
        if (ContractStatusID == 9) {
            tempCols.splice(5, 0, { key: 'colCo', name: 'Transport Company', width: 150 });
        }

        if (isIndividualScreen && ContractStatusID == 11) {
            tempCols.splice(
                0,
                tempCols.length,
                { key: 'reg', name: 'Reg Number', width: 110 },
                { key: 'cust', name: 'Customer Name', width: 250 },
                { key: 'depot', name: 'Depot', width: 180 },
                { key: 'chargeable', name: 'Chargeable', width: 120, align: 'right', filterable: 'no' },
                { key: 'nonchargeable', name: 'Non Chargeable', width: 120, align: 'right', filterable: 'no' },
                { key: 'sa', name: 'Service Area', width: 130 },
                { key: 'technician', name: 'Engineer', width: 150 },
                { key: 'winterSa', name: 'Winter Service Area', width: 140 },
                { key: 'summerSa', name: 'Summer Service Area', width: 160 },
                { key: 'startDate', name: 'Date', width: 90 }
            );
        }

        let regNoCol = tempCols.find((element) => element.key === 'reg');
        if (regNoCol) {
            regNoCol.formatter = renderRegNo;
        }
        return tempCols;
    }, []);

    const checkButton = (ev, label) => {
        let scheduleID = null;
        if (ContractStatusID == 1) scheduleID = ev.summerServiceScheduleID;
        if (ContractStatusID == 5) scheduleID = ev.onhireScheduleID;
        if (ContractStatusID == 7) scheduleID = ev.offhireScheduleID;
        // if (ContractStatusID == 10) scheduleID = ev.factoryInspectionScheduleID;
        setOpenDialog({ [label]: true });
        setState((st) => ({
            ...st,
            selectedRowData: ev,
            scheduleID: scheduleID
        }));
        // pullApiData();
    };

    const closeTheDialog = (res) => {
        setOpenDialog({});
        // setState((st) => ({
        //     ...st,
        //     checkedVehicleList: []
        // }));

        setState((st) => {
            const newSt = { ...st };
            newSt.checkedVehicleList = [];
            if (res) newSt.isReload = new Date();
            return newSt;
        });
    };

    const onRowDataBound = (e, $row, id, record, GridRef) => {
        const $checkbox = $row.find('input[type="checkbox"][data-role="selectRow"]');
        const $cell = $checkbox.closest('td');

        if (!record.contractVehicleID || (ContractStatusID == 3 && record.contractStatusID == 1)) {
            $checkbox.prop('disabled', true);
            $cell.children().css('visibility', 'hidden');
        } else {
            $checkbox.prop('disabled', false);
            $cell.children().css('visibility', 'visible');
        }

        if ((record.contractStatusID == 1 || record.contractStatusID == 2) && record.delCo && record.deliveryDate) {
            $row.css('background-color', '#FFD700');
            $row.css('color', 'white');
        } else {
            $row.css('background-color', 'white');
            $row.css('color', 'black');
        }
    };

    const urlState = `VehicleContract?StatusID=${ContractStatusID}`;

    return (
        <div className={isIndividualScreen ? 'screen' : ''}>
            {isIndividualScreen && (
                <BreadCrumbs
                    crumbs={[
                        { name: 'Home', path: '/' },
                        { name: screenName, active: true }
                    ]}
                />
            )}
            <GijgoGrid
                columns={columns}
                getUrl={urlState}
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                selectionType={
                    ContractStatusID !== 1 && ContractStatusID !== 5 && ContractStatusID !== 7
                        ? //  && ContractStatusID !== 10
                          'multiple'
                        : ''
                }
                selectionMethod={
                    ContractStatusID !== 1 && ContractStatusID !== 5 && ContractStatusID !== 7
                        ? // && ContractStatusID !== 10
                          'checkbox'
                        : ''
                }
                showCheckboxColFilterBtn={
                    ContractStatusID !== 1 && ContractStatusID !== 5 && ContractStatusID !== 7
                        ? // && ContractStatusID !== 10
                          mailButton
                        : null
                }
                onRowDataBound={(e, $row, id, record, GridRef) => onRowDataBound(e, $row, id, record, GridRef)}
                isReload={state.isReload}
                // btnTitle="Add Contract Schedule"
                // onBtnClick={addBtnClicked}
                downloadBtnName={'Download XLSX'}
                downloadCustomUrl={downloadPdf}
            />
            {openDialog.complete ? (
                <DialogComp title={`Complete Schedule`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <CompleteScheduleModalForContract scheduleID={state.scheduleID} rowData={state.selectedRowData} onClose={closeTheDialog} />
                </DialogComp>
            ) : null}
            {openDialog.setDeliveryDateModal ? (
                <DialogComp title={`Arrange Delivery`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetDeliveryDateModal rowData={state.selectedRowData} onClose={closeTheDialog} checkedVehicleList={state.selectedRecords} />
                    <SelectedVehicleTableComp selectedRecords={state.selectedRecords} />
                </DialogComp>
            ) : null}
            {openDialog.setCollectedModal ? (
                <DialogComp title={`Collected`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetCollectedModal rowData={state.selectedRowData} onClose={closeTheDialog} checkedVehicleList={state.selectedRecords} />
                    <SelectedVehicleTableComp selectedRecords={state.selectedRecords} />
                </DialogComp>
            ) : null}
            {openDialog.setOnsiteDateModal ? (
                <DialogComp title={`Set Vehicle Onsite`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetOnsiteDateModal rowData={state.selectedRowData} onClose={closeTheDialog} checkedVehicleList={state.selectedRecords} />
                    <SelectedVehicleTableComp selectedRecords={state.selectedRecords} />
                </DialogComp>
            ) : null}
            {openDialog.setPauseCompleted ? (
                <DialogComp title={`Contract Pause / Complete`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetPauseCompleted rowData={state.selectedRowData} onClose={closeTheDialog} checkedVehicleList={state.selectedRecords} />
                    <SelectedVehicleTableComp selectedRecords={state.selectedRecords} />
                </DialogComp>
            ) : null}
            {openDialog.setOffHireModal ? (
                <DialogComp title={`Set Vehicle Off Hire`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetOffHireModal
                        rowData={state.selectedRowData}
                        winterEndDate={state.selectedRecords[0].earliestOffHire}
                        contractWinterEndDate={state.selectedRecords[0].earliestOffHire}
                        onClose={closeTheDialog}
                        checkedVehicleList={state.selectedRecords}
                        selectedRecords={state.selectedRecords}
                    />
                    <SelectedVehicleTableComp selectedRecords={state.selectedRecords} showEarliestOffHire={true} />
                </DialogComp>
            ) : null}
            {openDialog.setVehiclePickedModal ? (
                <DialogComp title={`Vehicle Picked`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetVehiclePickedModal rowData={state.selectedRowData} onClose={closeTheDialog} checkedVehicleList={state.selectedRecords} />
                    <SelectedVehicleTableComp selectedRecords={state.selectedRecords} />
                </DialogComp>
            ) : null}
            {openDialog.setAwaitingFactoryInspection ? (
                <DialogComp title={`Set Vehicle Arrive Date`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetAwaitingFactoryInspection rowData={state.selectedRowData} onClose={closeTheDialog} checkedVehicleList={state.selectedRecords} />
                    <SelectedVehicleTableComp selectedRecords={state.selectedRecords} />
                </DialogComp>
            ) : null}
            {openDialog.setResumeContract ? (
                <DialogComp title={`Resume Contract`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetResume rowData={state.selectedRowData} onClose={closeTheDialog} checkedVehicleList={state.selectedRecords} />
                    <SelectedVehicleTableComp selectedRecords={state.selectedRecords} />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default ContractStatusScreen;
